import React from 'react'
import { IModal } from '../../reducers/modals'

function ModalContainer({ modals }: IModalContainer & IModalContainerDispatch) {
  const openModals = modals.map(modal =>
    React.cloneElement(modal.element, { modalId: modal.id, open: true }),
  )
  return <>{openModals}</>
}

export default ModalContainer

export interface IModalContainer {
  modals: IModal[]
}

export interface IModalContainerDispatch {
  closeModal: (id: string) => void
}

enum Modals {
  TemplateSendModal = 'TemplateSendModal',
  CopyModal = 'CopyModal',
  TransferModal = 'TransferModal',
  ReservationDeleteModal = 'ReservationDeleteModal',
  RoomDeleteModal = 'RoomDeleteModal',
  EditRoom = 'EditRoom',
  AddRoom = 'AddRoom',
  EditReservation = 'EditReservation',
  AddReservation = 'AddReservation',
  PrintModal = 'PrintModal',
  UpdateModal = 'UpdateModal',
  ActivateNewPriceGrid = 'ActivateModal',
  OpenPriceFormModal = 'OpenPriceModal',
  UpdatePrepayment = 'UpdatePrepayment',
  OpenAirbnbPriceFormModal = 'OpenAirbnbPriceFormModal',
  DeleteUserModal = 'DeleteUserModal',
  RoomLimit = 'RoomLimit',
}

export { Modals }
